import { GlobalState } from 'ha/types/store';

export const getCountryCode = (state: GlobalState) =>
  state.search.loadState.countryCode;
export const getCityCanonical = (state: GlobalState) =>
  state.search.loadState.cityCanonical;
export const getCountryCanonical = (state: GlobalState) =>
  state.search.loadState.countryCanonical;
